import { AxiosResponse } from "axios";
import { TAnalyticData } from "../pages/analytics";
import { AnalyticExport } from "../shared/types/analyticExport.type";
import { TAnalyticParams } from "../shared/types/analyticParameters.type";
import { TAnalyticView } from "../shared/types/analyticView.type";
import { TAnalyticsExport } from "../shared/types/analyticsExport.type";
import { TAnalyticsFilters } from "../shared/types/analyticsFilters.type";
import axiosInstance from "./base";

export type TNewConfig = {
  name: string;
  user: string;
  analytics_view_insight_parameters: {
    order_index: number;
    insight_parameter: string;
  }[];
};

export class AnalyticTable {
  static getAnalyticsParameters(
    lang: string,
  ): Promise<AxiosResponse<TAnalyticParams[]>> {
    return axiosInstance.get(
      "insight_parameters?available_as_analytics_parameter=true&page=1&itemsPerPage=1000".concat(
        `&lang=${lang}`,
      ),
    );
  }

  static saveNewConfig(
    data: TNewConfig,
  ): Promise<AxiosResponse<TAnalyticView>> {
    return axiosInstance.post("analytics_views", data);
  }

  static getConfigs(
    user?: string,
  ): Promise<AxiosResponse<Partial<TAnalyticView>[]>> {
    return axiosInstance.get(`analytics_views?user=${user}`);
  }

  static getViewById(
    id: number,
    isInitialLoad: boolean,
    selectedHorse?: number,
    lang: string = "en",
  ): Promise<AxiosResponse<TAnalyticView>> {
    return axiosInstance.get(
      `analytics_views/${id}`.concat(
        isInitialLoad
          ? "?include-default-data=true"
              .concat(selectedHorse ? `&horse=${selectedHorse}` : "")
              .concat(`&lang=${lang}`)
          : `?lang=${lang}`,
      ),
    );
  }

  static deleteView(id: number) {
    return axiosInstance.delete(`analytics_views/${id}`);
  }

  static updateView(
    id: number,
    data: Partial<TAnalyticView>,
  ): Promise<AxiosResponse<TAnalyticView>> {
    return axiosInstance.patch(`analytics_views/${id}`, data, {
      headers: {
        "Content-Type": "application/merge-patch+json",
      },
    });
  }

  static getFilters(
    id?: number,
    selectedHorse?: number,
    lang="en"
  ): Promise<AxiosResponse<TAnalyticsFilters>> {
    return axiosInstance.get(
      `users/${id}/analytics_filters`.concat(
        selectedHorse ? `?horse=${selectedHorse}&lang=${lang}` : `?lang=${lang}`,
      ),
    );
  }

  static getAnalytics(
    id: number,
    data: TAnalyticData,
    lang: string = "en",
  ): Promise<AxiosResponse> {
    return axiosInstance.post(`users/${id}/analytics_data?lang=${lang}`, data);
  }

  static exportAnalytics(data: any): Promise<AxiosResponse<TAnalyticsExport>> {
    return axiosInstance.post(`analytics_exports`, data);
  }

  static getExports(user?: string): Promise<AxiosResponse<AnalyticExport[]>> {
    let paramAnalyticView = encodeURIComponent("exists[analyticsView]").concat(
      "=1",
    );
    let paramOrder = encodeURIComponent("order[id]").concat("=DESC");
    return axiosInstance.get(
      `analytics_exports?user=${user}`
        .concat(`&${paramAnalyticView}`)
        .concat(`&${paramOrder}`),
    );
  }
}
